<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="main-card-body">
        <div class="body-header d-flex">
          <div>
            <el-breadcrumb separator-class="el-icon-arrow-right">
              <el-breadcrumb-item class="bold"
                >Cấu hình chấm công</el-breadcrumb-item
              >
              <el-breadcrumb-item>Danh sách ngày nghỉ</el-breadcrumb-item>
            </el-breadcrumb>
          </div>
          <div class="text-right">
            <el-button
              @click="fn_tableShowFormSearch()"
              type="info"
              round
              class="btn-default"
              >Ẩn/hiện tìm kiếm</el-button
            >
            <el-button
              v-if="mData.dataDefault.listFeature.includes('FT405')"
              round
              class="btn-default"
              @click="fn_syncDayOffCommon"
              >Đồng bộ</el-button
            >
            <el-button
              v-if="mData.dataDefault.listFeature.includes('FT402')"
              round
              class="btn-default"
              @click="fn_handle('create')"
              >Thêm mới</el-button
            >
          </div>
        </div>
        <div class="main-body">
          <div class="main-body-search">
            <b-collapse
              v-bind:visible="mData.tableRules.showFormSearch"
              id="myFormSearch"
              class="mb-3"
            >
              <b-card>
                <el-form
                  ref="mySearchForm"
                  label-position="top"
                  @submit.native.prevent
                  label-width="120px"
                  :model="mData.tableRules.dataSearch.value"
                  :rules="mData.tableRules.dataSearch.valid"
                >
                  <b-row>
                    <b-col md="4">
                      <el-form-item label="Tên ngày nghỉ">
                        <el-input
                          v-model="mData.tableRules.dataSearch.value.name"
                          @change="() => {mData.tableRules.dataSearch.value.name = mData.tableRules.dataSearch.value.name.trim()}"
                          clearable
                          placeholder=""
                        ></el-input>
                      </el-form-item>
                    </b-col>
                    <b-col md="3">
                      <el-form-item label="Năm">
                        <el-date-picker
                          v-model="mData.tableRules.dataSearch.value.year"
                          type="year"
                          placeholder=""
                          value-format="yyyy"
                        >
                        </el-date-picker>
                      </el-form-item>
                    </b-col>
                    <b-col md="3">
                      <el-form-item label="Ngày nghỉ lễ">
                        <el-date-picker
                          v-model="mData.tableRules.dataSearch.value.off_date"
                          type="date"
                          placeholder=""
                          format="dd/MM/yyyy"
                        >
                        </el-date-picker>
                      </el-form-item>
                    </b-col>
                    <b-col md="2">
                      <el-form-item label="Trạng thái">
                        <el-select
                          v-model="mData.tableRules.dataSearch.value.disabled"
                          clearable
                          placeholder=""
                        >
                          <el-option
                            v-for="item in mData.dataDefault.listTrangThaiKhoa"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          >
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </b-col>
                  </b-row>
                  <el-form-item class="text-center mb-0">
                    <el-button
                      round
                      native-type="submit"
                      class="btn-default"
                      @click="fn_tableSearch()"
                      >Tìm kiếm</el-button
                    >
                  </el-form-item>
                </el-form>
              </b-card>
            </b-collapse>
          </div>
          <div class="main-body-table mt-2">
            <div class="">
              <el-table
                :data="mData.tableRules.data"
                border
                @selection-change="fn_tableSelectionChange"
                @sort-change="fn_tableSortChange"
                style="width: 100%"
                :default-sort="{
                  prop: mData.tableRules.defaultSort[0],
                  order: mData.tableRules.defaultSort[1]
                }"
              >
                <el-table-column
                  type="selection"
                  width="40"
                  v-if="mData.tableRules.allowSelect"
                ></el-table-column>
                <el-table-column label="STT" width="45">
                  <template slot-scope="scope">
                    <div class="text-center">
                      {{ mData.tableRules.offset + scope.$index + 1 }}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="year"
                  align="center"
                  label="Năm"
                  width="100"
                >
                </el-table-column>
                <el-table-column
                  prop="type"
                  align="center"
                  label="Loại"
                  width="180"
                >
                  <template slot-scope="scope">
                    {{ scope.row.type }}
                    {{
                      scope.row.nghi_bu_ngay
                        ? "(" + scope.row.nghi_bu_ngay + ")"
                        : ""
                    }}
                  </template>
                </el-table-column>
                <el-table-column
                  prop="name"
                  label="Tên ngày nghỉ"
                  min-width="250"
                ></el-table-column>
                <el-table-column
                  prop="off_date"
                  align="center"
                  label="Ngày nghỉ"
                  min-width="150"
                ></el-table-column>
                <el-table-column label="Khóa" width="75" align="center">
                  <template slot-scope="scope">
                    <el-checkbox
                      :disabled="
                        !mData.dataDefault.listFeature.includes('FT404')
                      "
                      v-model="scope.row.disabled"
                      @change="
                        fn_changeTrangThaiKhoa(scope.row.id, scope.row.disabled)
                      "
                    ></el-checkbox>
                  </template>
                </el-table-column>
                <el-table-column
                  align="center"
                  label="Thao tác"
                  width="150"
                  v-if="
                    mData.dataDefault.listFeature.includes('FT404') ||
                      mData.dataDefault.listFeature.includes('FT403')
                  "
                >
                  <template slot-scope="scope">
                    <el-button
                      size="mini"
                      plain
                      round
                      type="primary"
                      @click="fn_handle('update', scope.$index, scope.row)"
                      v-b-popover.hover.left="aLang.c_update"
                      v-if="mData.dataDefault.listFeature.includes('FT404')"
                    >
                      <i class="far fa-edit"></i>
                    </el-button>
                    <el-button
                      size="mini"
                      plain
                      round
                      type="danger"
                      @click="fn_handle('delete', scope.$index, scope.row)"
                      v-b-popover.hover.left="aLang.c_delete"
                      v-if="mData.dataDefault.listFeature.includes('FT403')"
                    >
                      <i class="fas fa-trash-alt"></i>
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>
              <b-row class="mt-2" v-if="mData.tableRules.allowPaging">
                <div class="col-md-4">
                  <div v-if="mData.tableRules.allowSelect">
                    {{ aLang.c_select }}:
                    {{ mData.tableRules.recordSelected.length }}
                  </div>
                </div>
                <div class="col-md-8 text-right">
                  <el-pagination
                    @size-change="fn_tableSizeChange"
                    @current-change="fn_tableCurentChange"
                    @prev-click="fn_tablePrevClick"
                    @next-click="fn_tableNextClick"
                    :page-sizes="mData.tableRules.lengthMenu"
                    :page-size="mData.tableRules.limit"
                    :current-page="mData.tableRules.page"
                    background
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="mData.tableRules.total"
                    :pager-count="5"
                  ></el-pagination>
                </div>
              </b-row>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      :title="
        mData.viewMode == 'create' ? 'THÊM MỚI NGÀY NGHỈ' : 'Cập nhật NGÀY NGHỈ'
      "
      :visible.sync="formDialog"
      width="60%"
      :before-close="fn_resetForm"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div>
        <el-form
          :model="mData.dataForm"
          :rules="mData.validForm"
          ref="myForm"
          label-width="160px"
          label-position="top"
        >
          <!-- <div class="text-right">
            <b-form-checkbox
              v-model="isRange"
              @change="changeIsRange"
            >
              Khoảng ngày
            </b-form-checkbox>
          </div> -->
          <b-row class="mb-1">
            <b-col :md="mData.dataForm.type == 'HOLIDAY_RDO' ? '3' : '4'">
              <el-form-item label="Tên ngày nghỉ" prop="name">
                <el-input
                  type="text"
                  v-model="mData.dataForm.name"
                  :disabled="mData.viewMode == 'detail'"
                  placeholder=""
                ></el-input>
              </el-form-item>
            </b-col>
            <b-col :md="mData.dataForm.type == 'HOLIDAY_RDO' ? '3' : '4'">
              <el-form-item
                label="Loại ngày nghỉ"
                prop="type"
                v-if="loadDayOff"
              >
                <el-select
                  @input="forceUpdateUI"
                  v-model="mData.dataForm.type"
                  :disabled="mData.viewMode == 'detail'"
                  clearable
                  filterable
                  @change="changeType"
                >
                  <el-option
                    v-for="item in mData.dataDefault.listType"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </b-col>
            <b-col
              :md="mData.dataForm.type == 'HOLIDAY_RDO' ? '3' : '4'"
              v-if="mData.dataForm.type == 'HOLIDAY_RDO'"
            >
              <el-form-item label="Ngày nghỉ lễ bù" prop="day_off_id">
                <el-select
                  @input="forceUpdateUI"
                  v-model="mData.dataForm.day_off_id"
                  :disabled="mData.viewMode == 'detail'"
                  clearable
                  filterable
                >
                  <el-option
                    v-for="item in mData.dataDefault.listNgayNghi"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </b-col>
            <b-col :md="mData.dataForm.type == 'HOLIDAY_RDO' ? '3' : '4'" v-if="!isRange">
              <el-form-item label="Ngày nghỉ" prop="off_date">
                <el-date-picker
                  v-model="mData.dataForm.off_date"
                  type="date"
                  placeholder=""
                  format="dd/MM/yyyy"
                  :picker-options="pickerOptions"
                >
                </el-date-picker>
              </el-form-item>
            </b-col>
            <b-col :md="mData.dataForm.type == 'HOLIDAY_RDO' ? '3' : '4'" v-if="isRange">
              <el-form-item label="Ngày nghỉ" prop="list_off_date">
                <el-date-picker
                  v-model="mData.dataForm.list_off_date"
                  type="daterange"
                  range-separator="-"
                  start-placeholder="Từ ngày"
                  end-placeholder="đền ngày"
                  format="dd/MM/yyyy"
                  :picker-options="pickerOptions"
                >
                </el-date-picker>
              </el-form-item>
            </b-col>
          </b-row>
          <div class="text-center mt-2">
            <el-button
              v-if="mData.viewMode == 'create'"
              type="primary"
              round
              class="btn-default"
              @click="fn_submitForm('create')"
              >Lưu</el-button
            >
            <el-button
              v-if="mData.viewMode == 'update'"
              type="primary"
              round
              class="btn-default"
              @click="fn_submitForm('update')"
              >Lưu</el-button
            >
          </div>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import LanguageService from "../../../../service/LanguageService";
import DataService from "../../../../service/DataService";
import MethodService from "../../../../service/MethodService";
import DayOffModel from "./DayOffModel";
import DayOffApi from "../../../../moduleApi/DayOffApi";

export default {
  data() {
    return {
      aLang: LanguageService.lang,
      aElement: MethodService.element,
      formDialog: false,
      loadDayOff: true,
      pickerOptions: {
        disabledDate(time) {
          return false;
        },
      },
      isRange: false,
      mData: {
        id: null,
        listDayOffSelect: [],
        viewMode: "create",
        moduleName: "DayOff", //requied
        tableRules: MethodService.copyObject(DayOffModel.tableRules),
        dataForm: MethodService.copyObject(DayOffModel.dataForm),
        validForm: DayOffModel.validForm,
        dataDefault: {
          listType: DataService.listLoaiNgayNghi,
          listNgayNghi: [],
          listFeature: MethodService.getListFeatures(),
          listTrangThaiKhoa: DataService.listTrangThaiKhoa
        }
      },
      isHolidayRdo: false
    };
  },

  methods: {
    changeIsRange() {
      if (!this.isRange) this.mData.dataForm.list_off_date = undefined
      if (this.isRange) this.mData.dataForm.off_date = undefined
    },
    async fn_innitDataDefault() {
      let dataFilter = {
        filters: "type:in:HOLIDAY,OTHER&disabled!=true&"+
        (this.mData.tableRules.dataSearch.value.year ?"year="+this.mData.tableRules.dataSearch.value.year: "" )
      };
      const dayOffCommonApiRes = await DayOffApi.list(dataFilter);
      if (dayOffCommonApiRes.result && dayOffCommonApiRes.result.length > 0) {
        this.mData.dataDefault.listNgayNghi = dayOffCommonApiRes.result;
      }
    },
    async fn_initTable() {
      let dataFilter = {
        filters: this.mData.tableRules.filters
      };
      if (this.mData.tableRules.allowPaging) {
        dataFilter.limit = this.mData.tableRules.limit;
        dataFilter.offset = this.mData.tableRules.offset;
      }
      if (this.mData.tableRules.allowSorting) {
        dataFilter.sort = this.mData.tableRules.sort;
      }
      if (this.mData.tableRules.showUrl) {
        this.$router
          .replace({
            name:
              "Admin-Timekeeping-TimekeepingConfig-" +
              this.mData.moduleName +
              "-list",
            query: {
              limit: this.mData.tableRules.limit,
              page: this.mData.tableRules.page,
              sort: this.mData.tableRules.sort,
              filters: this.mData.tableRules.filters,
              showFormSearch: this.mData.tableRules.showFormSearch
            }
          })
          .catch(err => {});
      }
      let res = await DayOffApi.list(dataFilter);
      if (res.result) {
        let resData = await this.fn_changeData(res.result);
        this.mData.tableRules.data = resData;
        this.mData.tableRules.total = res.meta.total;
        if (resData) {
          this.mData.tableRules.page = this.mData.tableRules.offset / this.mData.tableRules.limit + 1;
          if(
              this.mData.tableRules.offset == this.mData.tableRules.total &&
              this.mData.tableRules.page > 1
            ) {
            this.mData.tableRules.page = this.mData.tableRules.page - 1;
            this.mData.tableRules.offset = (this.mData.tableRules.page - 1) * this.mData.tableRules.limit;
            this.fn_initTable();
          }
        }
      }
      this.forceUpdateUI();
    },
    //xử lý dữ liệu đầu ra
    async fn_changeData(resData) {
      resData.forEach(item => {
        item.off_date = MethodService.formatDate(item.off_date, "date");
        if (item.type == "HOLIDAY") {
          item.type = "Nghỉ lễ";
        } else if (item.type == "HOLIDAY_RDO") {
          item.type = "Nghỉ bù";
        } else if (item.type == "OTHER") {
          item.type = "Nghỉ khác";
        }
        let nghiBuNgay = this.mData.dataDefault.listNgayNghi.find(element => {
          return element.id == item.day_off_id;
        });
        if (nghiBuNgay && nghiBuNgay.off_date) {
          item.nghi_bu_ngay = MethodService.formatDate(
            nghiBuNgay.off_date,
            "date"
          );
        }
      });
      return resData;
    },
    //search
    fn_tableSearch() {
      this.$refs["mySearchForm"].validate(async valid => {
        if (valid) {
          this.mData.tableRules.filters = MethodService.filterTable(
            JSON.stringify(this.mData.tableRules.dataSearch)
          );
          this.mData.tableRules.offset = 0;
          this.mData.tableRules.sort = "";
          this.fn_innitDataDefault();
          this.fn_initTable();
        } else {
          MethodService.stopLadda();
          return false;
        }
      });
    },
    fn_dafaultSearch() {
      this.mData.tableRules.filters = MethodService.filterTable(
        JSON.stringify(this.mData.tableRules.dataSearch)
      );
      this.fn_innitDataDefault();
      this.fn_initTable();
    },
    async fn_syncDayOffCommon() {
      this.$confirm(
        "Bạn có chắc chắn muốn đòng bộ ngày nghỉ từ hệ thống không?",
        "Thông báo",
        {
          confirmButtonText: "Đồng ý",
          cancelButtonText: "Hủy",
          type: "info"
        }
      )
        .then(async () => {
          try {
            let res = await DayOffApi.SyncDayOffCommon();
            if (res.result) {
              this.fn_initTable();
              this.fn_innitDataDefault();
            }
          } catch (error) {
            console.log(error);
          }
        })
        .catch(() => {});
    },
    //event table
    fn_tableSortChange(column) {
      if (column.order == "ascending") {
        this.mData.tableRules.sort = column.prop;
      } else if (column.order == "descending") {
        this.mData.tableRules.sort = "-" + column.prop;
      } else {
        this.mData.tableRules.sort = "";
      }
      this.fn_initTable();
    },
    fn_tableShowFormSearch() {
      this.mData.tableRules.showFormSearch = !this.mData.tableRules
        .showFormSearch;
      let query = Object.assign({}, this.$route.query);
      query.showFormSearch = this.mData.tableRules.showFormSearch;
      this.$router.push({
        name:
          "Admin-Timekeeping-TimekeepingConfig-" +
          this.mData.moduleName +
          "-list",
        query: query
      });
    },
    //event table
    fn_tableSizeChange(limit) {
      this.mData.tableRules.limit = limit;
      this.fn_tableChangeOffset(this.mData.tableRules.page);
    },
    fn_tableCurentChange(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tablePrevClick(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tableNextClick(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tableChangeOffset(page) {
      this.mData.tableRules.page = page;
      this.mData.tableRules.offset =
        (this.mData.tableRules.page - 1) * this.mData.tableRules.limit;
      this.fn_initTable();
    },
    async fn_changeTrangThaiKhoa(id, trangThai) {
      let data = {
        id: id,
        disabled: trangThai
      };
      try {
        await DayOffApi.update(data);
      } catch (error) {
        console.log(error);
      }
    },

    fn_handle(type, scope, row) {
      if (type == "create") {
        this.mData.viewMode = "create";
        this.formDialog = true;
        MethodService.stopLadda();
      }
      if (type == "update") {
        this.mData.id = row.id;
        this.fn_getDataById(row.id);
        this.mData.viewMode = "update";
        this.formDialog = true;
      }
      if (type == "delete") {
        this.$confirm(LanguageService.lang.c_deleteConfirm, {
          confirmButtonText: LanguageService.lang.c_agree,
          cancelButtonText: LanguageService.lang.c_cancel,
          type: "warning"
        })
          .then(() => {
            this.fn_delete(row.id);
          })
          .catch(() => {});
      }
    },
    async fn_delete(id) {
      try {
        await DayOffApi.delete(id);
        this.fn_innitDataDefault();
        this.fn_initTable();
        this.mData.viewMode = "create";
      } catch (error) {
        if (error && error.code && error.code === 500) {
          window.toastr.error(error.detail);
        } else {
          window.toastr.error("Xóa thất bại");
        }
      }
    },
    //event table
    fn_tableSelectionChange(val) {
      var _this = this;
      this.mData.tableRules.recordSelected = [];
      val.forEach(function(element) {
        _this.mData.tableRules.recordSelected.push(element.id);
      });
    },
    //Form
    async fn_getDataById(id) {
      let dayOffApiRes = await DayOffApi.findById(id);
      if (dayOffApiRes.result) {
        this.mData.dataForm = dayOffApiRes.result;
        if (this.mData.dataForm.year) {
          this.mData.dataForm.year = String(this.mData.dataForm.year);
        }
      }
    },
    fn_submitForm(type) {
      if (this.mData.dataForm.name) {
        this.mData.dataForm.name = this.mData.dataForm.name.trim();
      }
      this.$refs["myForm"].validate(async valid => {
        if (valid) {
          let fullYear = "";
          if (this.mData.dataForm.off_date) {
            fullYear = new Date(this.mData.dataForm.off_date).getFullYear();
          }
          if (!this.mData.dataForm.type) {
            this.mData.dataForm.type = null;
          }
          let data = this.mData.dataForm;
          data.year = fullYear;
          try {
            if (type == "create") {
              await DayOffApi.create(data);
              this.fn_initTable();
              this.fn_resetForm();
              this.mData.viewMode = "create";
            } else if (type == "update") {
              data.id = this.mData.id;
              await DayOffApi.update(data);
              this.fn_initTable();
              this.fn_resetForm();
              this.mData.viewMode = "create";
            }
            this.fn_innitDataDefault();
          } catch (error) {
            console.log("error", error);
          }
        } else {
          MethodService.stopLadda();
          return false;
        }
      });
    },
    changeType() {
      this.loadDayOff = false;
      this.loadDayOff = true;
    },
    fn_resetForm() {
      this.formDialog = false;
      this.mData.dataForm = MethodService.copyObject(DayOffModel.tableRules);
      this.$refs["myForm"].resetFields();
    },
    forceUpdateUI() {
      this.$forceUpdate();
    },
    fn_hashUrl() {
      if (this.$route.query.limit) {
        this.mData.tableRules.limit = parseInt(this.$route.query.limit);
      }
      if (this.$route.query.page) {
        this.mData.tableRules.page = parseInt(this.$route.query.page);
      }
      if (this.$route.query.limit && this.$route.query.page) {
        this.mData.tableRules.offset =
          (this.mData.tableRules.page - 1) * this.mData.tableRules.limit;
      }
      if (this.$route.query.sort) {
        this.mData.tableRules.sort = this.$route.query.sort;
        this.mData.tableRules.defaultSort[0] = this.mData.tableRules.sort;
        if (this.mData.tableRules.sort.indexOf("-") != -1) {
          this.mData.tableRules.defaultSort[1] = "descending";
        } else {
          this.mData.tableRules.defaultSort[1] = "ascending";
        }
      }

      if (this.$route.query.showFormSearch == "true") {
        this.mData.tableRules.showFormSearch = true;
      }
      if (this.$route.query.showFormSearch == "false") {
        this.mData.tableRules.showFormSearch = false;
      }
      if (this.$route.query.filters) {
        this.mData.tableRules.filters = this.$route.query.filters;
        this.mData.tableRules.dataSearch.value = MethodService.stringToObject(
          this.mData.tableRules.filters
        )
        let m1 = this.mData.tableRules.filters.match(/\$vn_text=([^&]*)(&|$)/);
        if (m1) {
          this.$set(this.mData.tableRules.dataSearch.value, 'name', decodeURIComponent(m1[1]));
        }
      }
      if (!this.mData.tableRules.dataSearch.value.year) {
        this.mData.tableRules.dataSearch.value.year = new Date()
          .getFullYear()
          .toString();
      }
    },
  },
  async created() {
    await this.fn_hashUrl();
    await this.fn_dafaultSearch();
  },
};
</script>
